export default __webpack_public_path__ + "static/media/12-16.1430f844.png";